import { useSelector } from 'react-redux';
import { Trans } from 'react-i18next';

import getApplicationReportingStartDateSelector from '/business/shared/state/selectors/application/model/getApplicationReportingStartDateSelector';
import getApplicationReportingEndDateSelector from '/business/shared/state/selectors/application/model/getApplicationReportingEndDateSelector';

import StyledReportingPeriod from './__styled__/StyledReportingPeriod';
import useTranslatedDate from '/business/shared/hooks/useTranslatedDate';

type ReportingPeriodDate = Date | string | null | undefined;

type ReportingPeriodProps = {
  $extraMarginLeft?: boolean;
  $fontSize?: string;
  $green?: boolean;
  $strong?: boolean;
  $white?: boolean;
  reportingEndDateOverride?: ReportingPeriodDate;
  reportingStartDateOverride?: ReportingPeriodDate;
  yearOffset?: number;
};

const getDateValue = (date: ReportingPeriodDate) => {
  if (date === null) {
    return 0;
  }
  if (date === undefined) {
    return Number.NaN;
  }
  return date;
};

export function ReportingPeriod({
  reportingEndDateOverride = null,
  reportingStartDateOverride = null,
  $green = false,
  $white = false,
  $strong = false,
  $extraMarginLeft = false,
  $fontSize = 'inherit',
  yearOffset = 0,
}: ReportingPeriodProps) {
  const reportingStartDate = useSelector(getApplicationReportingStartDateSelector) || null;
  const reportingEndDate = useSelector(getApplicationReportingEndDateSelector) || null;

  const baseDateStart = new Date(getDateValue(reportingStartDateOverride || reportingStartDate));
  const baseDateEnd = new Date(getDateValue(reportingEndDateOverride || reportingEndDate));
  baseDateStart.setFullYear(baseDateStart.getFullYear() + yearOffset);
  baseDateEnd.setFullYear(baseDateEnd.getFullYear() + yearOffset);
  const start = useTranslatedDate({ date: baseDateStart });
  const end = useTranslatedDate({ date: baseDateEnd });
  return (
    <StyledReportingPeriod
      $green={$green}
      $white={$white}
      $strong={$strong}
      $extraMarginLeft={$extraMarginLeft}
      $fontSize={$fontSize}
    >
      {/* @i18n: 1 January 2026 to 31 December 2026 */}
      <Trans
        i18nKey="business:SiteComponents.reportingPeriod.dateSpan"
        values={{ start, end }}
        components={{ startDate: <strong />, endDate: <strong /> }}
      />
    </StyledReportingPeriod>
  );
}

export default ReportingPeriod;
